import { createContext, useEffect, useState } from "react";
import { UserProfile } from "../types/User.type";
import { useNavigate } from "react-router";
import { loginApi, registerApi } from "../services/AuthService";
import React from "react";
import axios from "axios";

type UserContextType = {
    user: UserProfile | null;
    token: string | null;
    registerUser: (email: string, username: string, password: string) => void;
    loginUser: (username: string, password: string) => void;
    logout: () => void;
    isLoggedIn: () => boolean;
    logedIsAdmin: () => boolean;
};

type Props = { children: React.ReactNode };

const UserContext = createContext<UserContextType>({} as UserContextType);

export const UserProvider = ({ children }: Props) => {
    const navigate = useNavigate();
    const [token, setToken] = useState<string | null>(null);
    const [user, setUser] = useState<UserProfile | null>(null);
    const [isReady, setisReady] = useState(false);

    useEffect(() => {
        const user = localStorage.getItem("user");
        const token = localStorage.getItem("token");
        if (user && token) {
            setUser(JSON.parse(user));
            setToken(token);
            axios.defaults.headers.common["Authorization"] = "Bearer " + token;
        }
        setisReady(true);
    }, []);

    const registerUser = async (
        email: string,
        username: string,
        password: string
    ) => {
        await registerApi(email, username, password).then((res) => {
            if (res && res.status === 201) {
                localStorage.setItem("token", res?.data.token);
                const userObj = {
                    username: res?.data.user.username,
                    email: res?.data.user.email,
                    is_superuser: res?.data.user.is_superuser,
                };
                localStorage.setItem("user", JSON.stringify(userObj));
                setToken(res?.data.token!);
                setUser(userObj!);
                navigate("");
            } else {
                throw new Error("Error register(400)");
            }
        });
    };
    const loginUser = async (username: string, password: string) => {
        await loginApi(username, password).then((res) => {
            if (res?.status === 200) {
                localStorage.setItem("token", res?.data.token);
                const userObj = {
                    username: res?.data.user.username,
                    email: res?.data.user.email,
                    is_superuser: res?.data.user.is_superuser,
                };
                localStorage.setItem("user", JSON.stringify(userObj));
                setToken(res?.data.token!);
                setUser(userObj!);
                navigate("");
            } else {
                throw new Error("Error Login(404)");
            }
        });
    };

    const isLoggedIn = () => {
        return !!user;
    };

    const logedIsAdmin = () => {
        if (!!user) {
            return user.is_superuser;
        }
        return false;
    };

    const logout = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        setUser(null);
        setToken("");
        navigate("/login");
    };

    return (
        <UserContext.Provider
            value={{
                loginUser,
                user,
                token,
                logout,
                isLoggedIn,
                registerUser,
                logedIsAdmin,
            }}
        >
            {isReady ? children : null}
        </UserContext.Provider>
    );
};

export const useAuth = () => React.useContext(UserContext);
